<template>
	<div class="service">
		<div class="otitle">
			<div>订单编号: {{mydata.order.trade_no}}</div>
			<div>订单状态: {{mydata.order.order_status_str}}</div>
		</div>
		<div class="table">
			<el-table :data="mydata.order_detail" style="width: 100%" border header-cell-class-name="custom-class">
				<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
					width="110px">
				</el-table-column>
				<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
				</el-table-column>
				<el-table-column label="渠道" align="center" header-align="center">
					<template slot-scope="scope">
						{{mydata.shop.shop_name}}
					</template>
				</el-table-column>
				<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_season" label="季度" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="price_for_buyer" label="单价" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="num" label="下单数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="true_num" label="实发数量" align="center" header-align="center">
				</el-table-column>
			</el-table>

			<div class="item">
				<div class="ohead">
					修改快递单号
				</div>
				<div class="table" v-for="(v,k) in form" :key="k">
					<el-form :model="v" :inline="true" :rules="rules" :ref="'ruleForm'+k" label-width="140px" class="demo-ruleForm">
						<el-form-item label="新实发快递" prop="delivery_id">
							<el-select v-model="v.delivery_id" placeholder="请选择快递" filterable>
								<el-option :label="x.name" :value="x.id" v-for="(x,y) in appdata.list.delivery"
									:key="y">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="新快递单号" prop="delivery_num">
							<el-input placeholder="填写新快递单号" v-model="v.delivery_num">
							</el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Gaidanhao',
		data() {
			return {
				mydata: {
					buy_user: {},
					order: {},
					order_detail: [],
					oredr_delivery: [],
					shop: {},
				},

				ruleForm: {
					delivery_id: "",
					delivery_num: ""
				},
				
				form: [],

				rules: {
					delivery_id: [{
						required: true,
						message: '请选择快递',
						trigger: 'change'
					}],

					delivery_num: [{
						required: true,
						message: '请填写快递单号',
						trigger: 'blur'
					}]
				},
			}
		},

		mounted() {
			this.oninfo();
		},

		props: {
			checkobj: {
				type: Object,
				default: {}
			}
		},

		inject: ['appdata'],

		methods: {
			oninfo() {
				var obj = {
					trade_no: this.checkobj.trade_no
				}

				this.$axios.post('api/user/order_info', obj).then(res => {
					if (res.data.code == 0) {
						this.mydata = res.data.data;
						this.form = [];
						this.mydata.oredr_delivery.forEach((v,k)=>{
							var obj = {};
							obj.id = v.id;
							obj.trade_no = this.checkobj.trade_no;
							obj.delivery_id = v.delivery_id;
							obj.delivery_num = v.delivery_num;
							this.form.push(JSON.parse(JSON.stringify(obj)));
						})
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onsub() {
				var arr = [];
				var arr2 = [];
				this.form.forEach((v,k)=>{
					this.$refs['ruleForm'+k][0].validate((valid) => {
						if (valid) {
							arr.push(v)
						}
					})
				})
				
				if(arr.length == this.form.length) {
					arr.forEach((v,k)=>{
						this.mydata.oredr_delivery.forEach((x,y)=>{
							if(v.id == x.id) {
								if(v.delivery_id != x.delivery_id || v.delivery_num != x.delivery_num) {
									arr2.push(v);
								}
							}
						})
					})
				}
				this.$emit('sub', arr2);
			}
		}
	}
</script>

<style scoped lang="less">
	.otitle {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #EBEEF5;
		border-bottom: none;

		div {
			width: 50%;
			height: 40px;
			border-right: 1px solid #EBEEF5;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #606266;
		}

		div:nth-child(3) {
			border-right: none;
		}
	}

	.item {
		width: 100%;
		margin-bottom: 10px;
		margin-top: 10px;

		.ohead {
			width: 100%;
			height: 40px;
			font-size: 14px;
			font-weight: bold;
			color: #000;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #EBEEF5;
			margin-bottom: 20px;

			span {
				color: #ff4714;
				margin-left: 6px;
			}
		}
	}
	
	/deep/ .el-input {
		width: 206px;
	}
</style>



// WEBPACK FOOTER //
// src/common/gaidanhao.vue